import React from 'react';
import PropTypes from "prop-types";
import commonStyle from "commonStyle";

import './index.css';

const defaultStyle = {

};

export default class Button extends React.Component {
  render() {
    const {
      children,
      className = '',
      download,
      label,
      link,
      onClick,
      style,
      submit,
      theme,
    } = this.props;

    const extraConfig = {};

    if (download) {
      extraConfig.download = download;
    }

    let themeClass = '';

    switch(theme) {
      case 'danger':
        themeClass = ' button-danger';
        break;
      default:
        break;  
    }

    const mergedStyle = Object.assign({}, defaultStyle, style);

    let Component = null;

    if (submit) {
      Component = (
        <input
          className={`button ${className && `${className}`}${themeClass}`}
          style={mergedStyle}
          onClick={onClick}
          type='submit'
          value={children || label}
          {...extraConfig}
        />
      );
    } else {
      Component = (
        <a
          className={`button ${className && `${ className}`}${themeClass}`}
          href={link}
          style={mergedStyle}
          onClick={onClick}
          {...extraConfig}
        >
          {children || label}
        </a>
      );
    }

    return Component;
  }
};

Button.defaultProps = {
  style: {}
};

Button.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
};